// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sub_grid_wrapper {
  width: 100%;
  height: 100%;
}

.sub_grid_wrapper_first_row {
  display: grid;
  grid-auto-flow: row;
  width: 100%;
  height: 66.66%;
  gap: 0.25rem;
}

.sub_grid_wrapper_second_row {
  display: grid;
  grid-auto-flow: row;
  width: 100%;
  height: 33.33%;
  gap: 0.25rem;
}

.grid_wrapper {
  display: grid;
  grid-auto-flow: row;
  width: 100%;
  height: 100%;
  gap: 0.25rem;
}

.grid_wrapper_1_img {
  grid-template-columns: repeat(1, 1fr);
}

.grid_wrapper_2_img {
  grid-template-columns: repeat(2, 1fr);
}

.grid_wrapper_3_img {
  grid-template-columns: repeat(2, 1fr);
}

.grid_wrapper_4_img {
  grid-template-columns: repeat(3, 1fr);
}

.grid_wrapper_5_img {
  grid-template-columns: repeat(2, 1fr 1fr);
}

.img {
  height: 100%;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
}

.show_more_img {
  height: 100%;
  width: 100%;
  overflow: hidden;
  opacity: 0.5;
  position: relative;
}

.show_more_text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  color: white;
}

.img_1_1 {
  grid-column: 1;
  grid-row: 1;
}

.img_2_1 {
  grid-column: 1/2;
  grid-row: 1;
}

.img_2_2 {
  grid-column: 2;
  grid-row: 1;
}

.img_3_1 {
  grid-column: 1/3;
  grid-row: 1/3;
}

.img_3_2 {
  grid-row: 3;
  grid-column: 1/2;
}

.img_3_3 {
  grid-row: 3;
  grid-column: 2/3;
}

.img_4_1 {
  grid-column: 1/4;
  grid-row: 1/3;
}

.img_4_2 {
  grid-row: 3;
  grid-column: 1/2;
}

.img_4_3 {
  grid-row: 3;
  grid-column: 2/3;
}

.img_4_4 {
  grid-row: 3;
  grid-column: 3;
}

.img_5_1 {
  grid-column: 1/3;
  grid-row: 1/3;
}

.img_5_2 {
  grid-row: 1;
  grid-column: 3/5;
}

.img_5_3 {
  grid-row: 3;
  grid-column: 1/2;
}

.img_5_4 {
  grid-row: 3;
  grid-column: 2/3;
}

.img_5_5 {
  grid-row: 3;
  grid-column: 3/5;
}

/* sub-grid-second-row */
.sub_grid_wrapper_3_img {
  grid-template-columns: repeat(3, 1fr);
}

.sub_img_3_1 {
  grid-column: 1/2;
  grid-row: 2;
}

.sub_img_3_2 {
  grid-column: 2/3;
  grid-row: 2;
}

.sub_img_3_3 {
  grid-column: 3;
  grid-row: 2;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/ui/auth/registration/grid-style.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAEF;;AACA;EACE,qCAAA;AAEF;;AACA;EACE,qCAAA;AAEF;;AAAA;EACE,qCAAA;AAGF;;AADA;EACE,qCAAA;AAIF;;AAFA;EACE,yCAAA;AAKF;;AAFA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAKF;;AAFA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAKF;;AAFA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,YAAA;AAKF;;AAFA;EACE,cAAA;EACA,WAAA;AAKF;;AAFA;EACE,gBAAA;EACA,WAAA;AAKF;;AAHA;EACE,cAAA;EACA,WAAA;AAMF;;AAHA;EACE,gBAAA;EACA,aAAA;AAMF;;AAHA;EACE,WAAA;EACA,gBAAA;AAMF;;AAJA;EACE,WAAA;EACA,gBAAA;AAOF;;AAJA;EACE,gBAAA;EACA,aAAA;AAOF;;AAJA;EACE,WAAA;EACA,gBAAA;AAOF;;AALA;EACE,WAAA;EACA,gBAAA;AAQF;;AANA;EACE,WAAA;EACA,cAAA;AASF;;AANA;EACE,gBAAA;EACA,aAAA;AASF;;AANA;EACE,WAAA;EACA,gBAAA;AASF;;AANA;EACE,WAAA;EACA,gBAAA;AASF;;AAPA;EACE,WAAA;EACA,gBAAA;AAUF;;AARA;EACE,WAAA;EACA,gBAAA;AAWF;;AARA,wBAAA;AAEA;EACE,qCAAA;AAUF;;AAPA;EACE,gBAAA;EACA,WAAA;AAUF;;AAPA;EACE,gBAAA;EACA,WAAA;AAUF;;AARA;EACE,cAAA;EACA,WAAA;AAWF","sourcesContent":[".sub_grid_wrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.sub_grid_wrapper_first_row {\n  display: grid;\n  grid-auto-flow: row;\n  width: 100%;\n  height: 66.66%;\n  gap: 0.25rem;\n}\n.sub_grid_wrapper_second_row {\n  display: grid;\n  grid-auto-flow: row;\n  width: 100%;\n  height: 33.33%;\n  gap: 0.25rem;\n}\n\n.grid_wrapper {\n  display: grid;\n  grid-auto-flow: row;\n  width: 100%;\n  height: 100%;\n  gap: 0.25rem;\n}\n\n.grid_wrapper_1_img {\n  grid-template-columns: repeat(1, 1fr);\n}\n\n.grid_wrapper_2_img {\n  grid-template-columns: repeat(2, 1fr);\n}\n.grid_wrapper_3_img {\n  grid-template-columns: repeat(2, 1fr);\n}\n.grid_wrapper_4_img {\n  grid-template-columns: repeat(3, 1fr);\n}\n.grid_wrapper_5_img {\n  grid-template-columns: repeat(2, 1fr 1fr);\n}\n\n.img {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.show_more_img {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  opacity: 0.5;\n  position: relative;\n}\n\n.show_more_text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.5rem;\n  color: white;\n}\n\n.img_1_1 {\n  grid-column: 1;\n  grid-row: 1;\n}\n\n.img_2_1 {\n  grid-column: 1/2;\n  grid-row: 1;\n}\n.img_2_2 {\n  grid-column: 2;\n  grid-row: 1;\n}\n\n.img_3_1 {\n  grid-column: 1 / 3;\n  grid-row: 1 / 3;\n}\n\n.img_3_2 {\n  grid-row: 3;\n  grid-column: 1 / 2;\n}\n.img_3_3 {\n  grid-row: 3;\n  grid-column: 2 / 3;\n}\n\n.img_4_1 {\n  grid-column: 1 / 4;\n  grid-row: 1 / 3;\n}\n\n.img_4_2 {\n  grid-row: 3;\n  grid-column: 1 / 2;\n}\n.img_4_3 {\n  grid-row: 3;\n  grid-column: 2 / 3;\n}\n.img_4_4 {\n  grid-row: 3;\n  grid-column: 3;\n}\n\n.img_5_1 {\n  grid-column: 1 / 3;\n  grid-row: 1/3;\n}\n\n.img_5_2 {\n  grid-row: 1;\n  grid-column: 3/5;\n}\n\n.img_5_3 {\n  grid-row: 3;\n  grid-column: 1 / 2;\n}\n.img_5_4 {\n  grid-row: 3;\n  grid-column: 2/3;\n}\n.img_5_5 {\n  grid-row: 3;\n  grid-column: 3/5;\n}\n\n/* sub-grid-second-row */\n\n.sub_grid_wrapper_3_img {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.sub_img_3_1 {\n  grid-column: 1 / 2;\n  grid-row: 2;\n}\n\n.sub_img_3_2 {\n  grid-column: 2 / 3;\n  grid-row: 2;\n}\n.sub_img_3_3 {\n  grid-column: 3;\n  grid-row: 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
